import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchCampaigns as fetchCampaignsService, fetchCampaign as fetchCampaignService } from "./campaign.service";
import { GetCampaignResponse, GetCampaignsResponse } from "./campaign.types";
import { handleApiError } from "@/app/utils/handleApiError";
import { FilterRequest } from "../filters/filters.types";

export const getCampaigns = createAsyncThunk<
  GetCampaignsResponse & { page: number },
  { page?: number },
  { rejectValue: string }
>("campaign/getCampaigns", async ({ page = 1 }, { rejectWithValue }) => {
  try {
    const response = await fetchCampaignsService(page);
    return { ...response, page };
  } catch (err) {
    return rejectWithValue(handleApiError(err));
  }
});

export const getCampaign = createAsyncThunk<
  GetCampaignResponse,
  { code: string; page?: number; filters?: Partial<FilterRequest> },
  { rejectValue: string }
>("campaign/getCampaign", async ({ code, page, filters }, { rejectWithValue }) => {
  try {
    return await fetchCampaignService(code, page, filters);
  } catch (err) {
    return rejectWithValue(handleApiError(err));
  }
});